import React from "react";
import { Link } from "react-router-dom";
import asknowLogo from "../../../assets/icons/asknow.svg";
import userIcon from "../../../assets/icons/user.svg";

import defaultStyle from "./Topbar.module.scss";
import config from "appConfig";
import { authProvider } from "../../../providers/local";
import { Icon, Popover } from "@jelly/ui";

interface TopBarProps {
  headerText?: string;
  headerUrl?: string;
  onHeaderClick?: () => void;
}

const TopBar: React.FC<TopBarProps> = ({ headerText, headerUrl, onHeaderClick }: TopBarProps) => {
  function handleLogoutClick(): void {
    authProvider.logout();
  }

  function renderTitle(): JSX.Element | null {
    if (headerText) {
      if (onHeaderClick) {
        return (
          <p className={defaultStyle.title} onClick={onHeaderClick}>
            {headerText}
          </p>
        );
      }

      if (headerUrl) {
        return (
          <a href={headerUrl} className={defaultStyle.title}>
            {headerText}
          </a>
        );
      }

      return <p className={defaultStyle.title}>{headerText}</p>;
    }

    return null;
  }

  function renderPopoverList(): JSX.Element {
    return (
      <div className={defaultStyle.popoverContent}>
        <div className={defaultStyle.popoverList}>
          <Link className={defaultStyle.popoverListElement} to="/dashboard">
            <p>Dashboard</p>
            <Icon className="cil-widgets" />
          </Link>
          <div className={defaultStyle.popoverListElement} onClick={handleLogoutClick}>
            <p className={defaultStyle.logoutText}>Logout</p>
            <Icon className="cil-account-logout" theme="primary" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={defaultStyle.container}>
      <div className={defaultStyle.titleWrapper}>
        <a href={config.LANDING_PAGE_URL}>
          <img className={defaultStyle.logo} src={asknowLogo} alt="Asknow" />
        </a>
        {renderTitle()}
      </div>
      <Popover
        placement="bottom-start"
        mainTxt="Popover"
        trigger="click"
        customContent={renderPopoverList()}
        style={defaultStyle}
      >
        <div className={defaultStyle.userWrapper}>
          <p className={defaultStyle.username}>{authProvider.getAuthStore()?.username || ""}</p>
          <img src={userIcon} alt="User" />
        </div>
      </Popover>
    </div>
  );
};

export default TopBar;
